export default {
    name: "Render",
    functional: true,
    props: {
        render: Function,
        renderData: null,
    },
    render: (h, ctx) => {
        const params = ctx.props.renderData;
        return ctx.props.render(h, params);
    },
};



// WEBPACK FOOTER //
// ./src/components/render.js